export default __webpack_public_path__ + "static/media/registrocerrado_1coloquio3.888fad61.jpg";